// Import necessary dependencies and components
import React, { useState, useEffect, useContext } from "react";
import Axios from "axios";
import Modal from "react-bootstrap/Modal";
import Alert from "react-bootstrap/Alert"; // Import Alert for messages
import AuthContext from "../context/AuthContext";
import { API_URL } from "../components/api";
import LabelsTable from "./LabelsTable";
import Select from "react-select";

// Main Apartments component
function Labels() {
  // State hook to manage modal visibility
  const [show, setShow] = useState(false);

  // Functions to handle modal open and close actions
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="Buildings">
      {/* Button to trigger the modal for adding an label */}
      <button onClick={handleShow} className="edit-client" style={{marginTop:"10px", marginLeft:"10px"}}>
        Add Label
      </button>
      <div className="main">
        {/* Render LabelsTable component to display list of apartments */}
        <LabelsTable />
      </div>
      {/* Modal to display the label form */}
      <Modal show={show} onHide={handleClose} className="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>Add Apartment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Label component is passed parentFunction to close modal */}
          <LabelForm parentFunction={handleClose} />
        </Modal.Body>
      </Modal>
    </div>
  );
}

// ApartmentForm component where user can add apartment details
function LabelForm(props) {
  // Context hook to get current user details
  const { user } = useContext(AuthContext);
  const authTokens = JSON.parse(localStorage.getItem("authTokens"));

  // State hooks to manage form data and UI state
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  


  // Function to handle form submission for adding an apartment
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent page reload on form submission

    // API request to add apartment data
    Axios.post(
      `${API_URL}/administration/labels/`,
      {
        Action: "Post",
        label_name: name,
        label_description: description,
        userdealer: user.username,
      },
      {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
      }
    )
      .then((response) => {
        console.log("Label added:", response);
        setShowSuccess(true); // Show success message
        setTimeout(() => setShowSuccess(false), 3000); // Hide success message after 3 seconds
        props.parentFunction(); // Close modal after success
      })
      .catch((error) => {
        console.error("Error adding label:", error);
        setErrorMessage(
          error.response?.data?.message || "An error occurred while adding the label."
        );
        setShowError(true); // Show error message
        setTimeout(() => setShowError(false), 5000); // Hide error message after 5 seconds
      });
  };

  return (
    <>
      {/* Display success or error messages based on form submission status */}
      {showSuccess && (
        <Alert variant="success" onClose={() => setShowSuccess(false)} dismissible>
          Label added successfully!
        </Alert>
      )}
      {showError && (
        <Alert variant="danger" onClose={() => setShowError(false)} dismissible>
          {errorMessage}
        </Alert>
      )}
      {/* Form to input apartment details */}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Label Name:</label>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)} // Update label name on change
            placeholder="Enter label name"
          />
        </div>
        <div className="form-group">
          <label>Label Description:</label>
          <input
            type="text"
            className="form-control"
            value={description}
            onChange={(e) => setDescription(e.target.value)} // Update label description on change
            placeholder="Enter Description"
          />
        </div>
        {/* Submit button to add apartment */}
        <button type="submit" className="btn btn-success" style={{ marginTop: "10px" }}>
          Add Label
        </button>
      </form>
    </>
  );
}

export default Labels; // Export Labels component
